import { useRouteLoaderData } from 'react-router'

import { AppLoaderData } from '~/types/app'
import { FeatureFlags } from '~/types/flags'

export const useFeatureFlag = (flag: FeatureFlags): any => {
  const { flags } = useRouteLoaderData<AppLoaderData>('root') as AppLoaderData ?? { flags: {} }
  return flags?.[flag] ?? false
}